// extracted by mini-css-extract-plugin
export default {"modal":"modal--6e7e593","openedModal":"openedModal--9dfc424","close":"close--31b9899"};